import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { ReactElement, ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import { oktaClient } from 'packages/lib/auth';

interface LayoutProps {
  children: ReactNode;
}

function OktaSecurity({ children }: LayoutProps): ReactElement {
  const history = useHistory();

  const restoreOriginalUri = async (
    _: OktaAuth,
    originalUri: string
  ): Promise<void> => {
    history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  return (
    <Security oktaAuth={oktaClient} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
}

export default OktaSecurity;
